import { createRouter, createWebHistory } from 'vue-router';
import OnlyHeaderLayout from '@/layout/OnlyHeaderLayout.vue';
import Document from '@/views/Document.vue';
import NotFound from '@/views/NotFound.vue';
import Home from '@/views/Home.vue';

const routes = [
  {
    path: "/:catchAll(.*)*",
    component: NotFound
  },
  {
    path: "/",
    redirect: "/th"
  },
  {
    path: '/th',
    component: OnlyHeaderLayout,
    children: [
      {
        path: '',
        component: Home
      }
    ]
  },
  {
    path: "/th/docs",
    redirect: "/th/docs/overview/v1/getting-started"
  },
  {
    path: "/th/docs/overview",
    redirect: "/th/docs/overview/v1/getting-started"
  },
  {
    path: "/th/docs/overview/v1",
    redirect: "/th/docs/overview/v1/getting-started"
  },
  {
    path: "/th/docs/overview/:version",
    redirect: function (route) {
      location.href = route.fullPath + '/getting-started';
    }
  },
  {
    path: "/th/docs/overview/:version/:document",
    component: Document
  },
  {
    path: "/th/docs/references/:context/:version/:document",
    component: Document
  },
  {
    path : "/example/oauth2/v1/authorize/callback",
    component: OnlyHeaderLayout,
    children: [
      {
        path: '',
        component: () => import('@/views/ExampleOAuth2AuthorizeCallback.vue')
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: "history",
  routes
});

const toggleOrRemoveExpand = (isToggle) => {
  const el = document.querySelector(".app-sidemenu-layout");
  if (el) {
    const className = el.className || "";
    const arr = className.split(/\s+/ig);
    const index = arr.indexOf("expand");
    if (index >= 0) {
      arr.splice(index, 1);
    } else {
      if (isToggle) {
        arr.push("expand");
      }
    }
    el.className = arr.join(" ");
  }
};

document.addEventListener("click", (event) => {
  const el = event.target;
  const parent = el.parentElement;
  if (parent && parent.className === "app-sidemenu-toggle") {
    toggleOrRemoveExpand(true);
  } else if (el.tagName === "A") {
    const t = setTimeout(() => {
      clearTimeout(t);
      toggleOrRemoveExpand();
    }, 50);
  } else if (/.*(app-sidemenu-close).*/ig.test(el.className)) {
    toggleOrRemoveExpand();
  }
});

let windowInnerWidth = window.innerWidth;
window.addEventListener('resize', (event) => {
  const target = event.target;
  if (windowInnerWidth !== target.innerWidth) {
    windowInnerWidth = target.innerWidth;
    toggleOrRemoveExpand();
  }
});

let latestScroll = 0;
window.addEventListener('scroll', () => {
  const sideMenuLayout = document.querySelector(".app-sidemenu-layout");
  if (sideMenuLayout) {
    if (/.*(expand).*/ig.test(sideMenuLayout.className)) {
      window.scrollTo({ top: latestScroll });
      return;
    }
  }
  latestScroll = window.scrollY;
});

export default router;
